import { Button } from "@/components/ui/button";
import { CalendarCheck, MapPin, MessageCircle, Video, BadgeCheck, Phone } from "lucide-react";
import { CLINIC, whatsappLink } from "@/constants/clinic";
import { SundayBanner } from "@/components/site/SundayBanner";

export const Hero = () => (
  <section id="top" className="relative overflow-hidden">
    <div className="absolute -top-40 -right-40 h-[520px] w-[520px] rounded-full bg-accent blur-3xl opacity-70" />
    <div className="relative max-w-7xl mx-auto px-6 py-16 lg:py-24 grid lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-6">
        <p className="rise inline-flex items-center gap-2 rounded-full bg-accent text-primary px-4 py-1.5 text-sm font-medium" data-testid="hero-badge">
          <MapPin className="h-4 w-4" /> {CLINIC.title} · {CLINIC.city}
        </p>
        <h1 className="rise rise-1 mt-6 text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#1A252C]" data-testid="hero-title">
          Dr. Saurabh Agarwal Clinic
        </h1>
        <p className="rise rise-2 mt-6 text-base md:text-lg text-muted-foreground leading-relaxed max-w-xl">
          {CLINIC.doctor} is a Consultant Physician and Diabetologist in Lucknow, specialising in comprehensive diabetes
          management, metabolic disorders, thyroid diseases, hypertension and adult internal medicine. He combines
          evidence-based medical practice with personalised patient care. Book an in-clinic visit at one of three Lucknow clinics, or a secure online consultation.
        </p>
        <div className="rise rise-3 mt-10 flex flex-wrap gap-4">
          <Button asChild size="lg" className="rounded-full px-7 h-12 bg-[#FACC15] text-[#1E1B4B] hover:bg-[#EAB308] font-semibold shadow-md" data-testid="hero-book-btn">
            <a href="#book"><CalendarCheck className="mr-2 h-5 w-5" /> Book an appointment</a>
          </Button>
          <Button asChild size="lg" variant="outline" className="rounded-full px-7 h-12 border-primary/30 text-primary" data-testid="hero-whatsapp-btn">
            <a href={whatsappLink()} target="_blank" rel="noreferrer"><MessageCircle className="mr-2 h-5 w-5" /> WhatsApp +91 {CLINIC.whatsapp}</a>
          </Button>
          <Button asChild size="lg" variant="outline" className="rounded-full px-7 h-12 border-primary/30 text-primary" data-testid="hero-call-btn">
            <a href={`tel:+91${CLINIC.phone}`}><Phone className="mr-2 h-5 w-5" /> Call for appointments +91 {CLINIC.phone}</a>
          </Button>
        </div>
        <SundayBanner className="rise rise-3 mt-8 max-w-md" />
      </div>
      <div className="lg:col-span-6 relative rise rise-2">
        <img src="/images/doctor-photo.jpg" alt="Dr. Saurabh Agarwal" className="w-full h-[420px] lg:h-[520px] object-cover object-top rounded-3xl shadow-xl" data-testid="hero-image" />
        <div className="absolute -bottom-6 left-6 sm:-left-6 bg-white rounded-2xl shadow-lg p-5 border border-slate-100 w-72" data-testid="hero-availability-card">
          <p className="flex items-center gap-2 text-sm font-semibold text-primary"><BadgeCheck className="h-4 w-4" /> {CLINIC.doctor}</p>
          <p className="mt-3 text-sm text-[#1A252C] flex items-center gap-2"><MapPin className="h-4 w-4 text-secondary" /> 3 clinics across Lucknow</p>
          <p className="mt-1 text-sm text-[#1A252C] flex items-center gap-2"><Video className="h-4 w-4 text-secondary" /> Online · Mon – Sun, 9 AM – 9 PM</p>
        </div>
      </div>
    </div>
  </section>
);
